import { ShimmerDepartmentRender } from "components/app/shrimmer/Shrimmer";
import React from "react";

const RequestTypes = ({
  hovered,
  setHovered,
  setEditItemCategories,
  selectedProductGroupCode,
  handleClickCategory,
  loadingGetShopEmployeeRequestType,
  mergedRequestTypes,
}: any) => {
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
    >
      <div className="relative w-full ">
        <div className="flex space-x-2 w-full">
          <div
            onClick={() => {
              setEditItemCategories("");
              if (selectedProductGroupCode === "All") {
                setEditItemCategories("");
              }
              handleClickCategory({
                categoryName: "",
              });
            }}
            className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
              selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
            }`}
          >
            <span className="lg:text-sm md:text-sm text-[12px]">All</span>
          </div>
          <div className="space-x-2 flex ">
            {loadingGetShopEmployeeRequestType ? (
              <>
                <ShimmerDepartmentRender />
              </>
            ) : (
              <>
                {mergedRequestTypes?.map((group: any, index: any) => (
                  <div key={index} className="flex items-center relative z-1 ">
                    <div
                      className={`absolute z-10 top-0 right-0 text-white px-2 rounded-bl-md rounded-tr-md mt-0 ${
                        group.request_type === "Change DO Application Form"
                          ? " bg-cyan-500"
                          : group.request_type === "Change Shift Application Form"
                          ? " bg-pink-500"
                          : group.request_type === "Leave Application Form"
                          ? "bg-green-500"
                          : "bg-blue-500"
                      }`}
                    >
                      <span className="text-sm font-bold">{group.no_of_pending > 0 ? group.no_of_pending : ""}</span>
                    </div>

                    {group.request_type && (
                      <div
                        className={`flex items-center px-5 w-auto whitespace-nowrap lg:h-14 md:h-12 h-10 border rounded-md cursor-pointer font-semibold ${
                          selectedProductGroupCode === group.request_type ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200" : "dark:hover:bg-slate-900"
                        }`}
                        onClick={() => {
                          setEditItemCategories(group.request_type);
                          handleClickCategory({ categoryName: group.request_type });
                        }}
                      >
                        <div className="flex group">
                          <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">{group.request_type}</p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestTypes;
